import { MuiThemeProvider, StylesProvider, createGenerateClassName } from '@material-ui/core/styles';
import { clearError } from 'actionCreators/error';
import { fetchCourseTemplate, fetchInitialTemplate } from 'actionCreators/template';
import { theme as MuiTheme } from 'assets/theme';
import Environment from 'components/Shared/Environment';
import Error from 'components/Shared/Error';
import Pages from 'components/Pages';
import Router from 'components/Router';
import { ThemeProvider as ThemeProviderMaterial } from '@material-ui/core';
import { Fragment, PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import InternetStatus from 'components/Shared/InternetStatus';
import { BrowserRouter } from 'react-router-dom';
import ToastNotification from 'components/Shared/ToastNotification';
import Alert from 'components/Shared/Alert';
import houston from 'assets/themes/Houston';
import { CustomToast } from 'components/Shared/ToastCustom';

interface IState {
  isOffline: boolean;
}

interface IProps {
  isAuthenticated: boolean;
  template: any;
  fetchCourseTemplate: Function;
  clearError: Function;
  fetchInitialTemplate: Function;
}

const generateClassName = createGenerateClassName({
  productionPrefix: 'nutror',
});

class App extends PureComponent<IProps, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isOffline: false,
    };
  }

  componentDidMount() {
    window.addEventListener('offline', () => {
      this.setState({ isOffline: true });
    });

    window.addEventListener('online', () => {
      this.setState({ isOffline: false });
    });
    this.props.fetchInitialTemplate();
  }

  handleRenderRoute = async (props: any) => {
    const { courseHash } = props.match.params;

    clearError();

    if (courseHash && (!this.props.template.course || courseHash !== this.props.template.course.hash)) {
      if (this.props.template.course) {
        this.props.fetchCourseTemplate(courseHash);
      } else {
        document.body.style.visibility = 'hidden';
        this.props.fetchCourseTemplate(courseHash);
        document.body.style.visibility = 'visible';
      }
    }
  };

  render() {
    const isOffline = this.state.isOffline;

    if (window.location.pathname.endsWith('index.html')) {
      window.location.href = window.location.href.replace('/index.html', '');
      return null;
    }

    if (!this.props.template.base)
      return (
        <StylesProvider generateClassName={generateClassName}>
          <Fragment>
            <Environment />
            <Error />
          </Fragment>
        </StylesProvider>
      );

    return (
      <StylesProvider generateClassName={generateClassName}>
        <Fragment>
          <Helmet>
            <title>{this.props.template.base.title || 'Nutror'}</title>
          </Helmet>
          <InternetStatus isOffline={isOffline} />
          <MuiThemeProvider theme={MuiTheme}>
              <Environment />
              <Error />
              <ToastNotification />
              <ThemeProviderMaterial theme={houston}>
                <Alert />
                <CustomToast />
              </ThemeProviderMaterial>
              <BrowserRouter basename={this.props.template.base.subdomain ? undefined : '/v3'}>
                <Router onRender={this.handleRenderRoute} authenticated={this.props.isAuthenticated}>
                  <Pages />
                </Router>
              </BrowserRouter>
          </MuiThemeProvider>
        </Fragment>
      </StylesProvider>
    );
  }
}

const mapStateToProps = (state: any) => ({
  isAuthenticated: state.auth.isAuthenticated,
  template: state.template,
});

export default connect(mapStateToProps, {
  fetchCourseTemplate,
  clearError,
  fetchInitialTemplate,
})(App);
